export default __webpack_public_path__ + "media/src/assets/images/download-f7d2c7c98d312bc3d301621ddee05171.png";